import { useEffect, useState } from "react";
import { WalletConnect } from "./components/WalletConnect";
import { ShareToX } from "./components/ShareToX";
import { GameBoard } from "./components/GameBoard";
import { ResultModal } from "./components/ResultModal";
import { preloadImages } from "./game/images";
import { useMemoryGame } from "./game/useMemoryGame";
import { playGame } from "./web3/ritual";
import { spawnPersistentAgent } from "./web3/spawnAgent";
import { Analytics } from "@vercel/analytics/react";
import "./App.css";

declare global {
  interface Window {
    gtag?: (...args: any[]) => void;
  }
}

function App() {
  const [wallet, setWallet] = useState<string | null>(null);
  const [canPlay, setCanPlay] = useState(false);
  const [showResult, setShowResult] = useState(false);
  const [stats, setStats] = useState({ time: 0, moves: 0 });
  const [paying, setPaying] = useState(false);
  const [spawning, setSpawning] = useState(false);

  const game = useMemoryGame((s) => {
    setStats(s);
    setShowResult(true);
    window.gtag?.("event", "game_completed", {
      time: s.time,
      moves: s.moves,
    });
  });

  useEffect(() => {
    preloadImages();
  }, []);

  const handleConnected = (address: string) => {
    setWallet(address);
    window.gtag?.("event", "connect_wallet");
  };

  // ================== SPAWN AGENT FUNCTION ==================
  const handleSpawnAgent = async () => {
    if (!wallet) {
      alert("Vui lòng connect wallet trước!");
      return;
    }
    try {
      setSpawning(true);
      const receipt = await spawnPersistentAgent();
      alert(`✅ Spawn Persistent Agent thành công!\n\nTx Hash: ${receipt.transactionHash}\n\nBạn có thể kiểm tra trên explorer.`);
    } catch (e: any) {
      console.error(e);
      alert("Spawn thất bại: " + (e.message || e));
    } finally {
      setSpawning(false);
    }
  };
  // =========================================================

  const handleClickPlay = async () => {
    if (!wallet) {
      alert("Please connect wallet");
      return;
    }
    window.gtag?.("event", "play_clicked");
    try {
      setPaying(true);
      const receipt = await playGame();
      window.gtag?.("event", "payment_success");
      setCanPlay(true);
      game.resetGame();
      window.gtag?.("event", "game_started");
    } catch (e: any) {
      console.error("playGame error:", e);
      if (e?.code === 4001 || e?.reason === "rejected") {
        alert("Transaction rejected by user.");
      } else {
        alert(e?.message || "Payment failed");
      }
    } finally {
      setPaying(false);
    }
  };

  const handlePlayAgain = () => {
    setShowResult(false);
    setCanPlay(false);
  };

  return (
    <div className="app-root">
      <header className="app-header">
        <div>
          <h1>Ritual Flip Card</h1>
          <p className="subtitle">Pay-per-play memory game on Ritual testnet</p>
        </div>
        <div className="header-actions">
          <ShareToX />
          <WalletConnect onConnected={handleConnected} />
        </div>
      </header>

      <main className="app-main">
        <section className="top-bar">
          {/* Nút Spawn Agent */}
          {/* <button
            className="btn purple"
            onClick={handleSpawnAgent}
            disabled={!wallet || spawning}
            style={{ marginRight: '12px', backgroundColor: '#8b00ff', color: 'white' }}
          >
            {spawning ? "Đang Spawn..." : "🚀 Spawn Persistent Agent (Genesis 1000)"}
          </button> */}

          {/* Nút Play Game */}
          <button
            className="btn primary"
            onClick={handleClickPlay}
            disabled={!wallet || paying}
          >
            {paying ? "Processing..." : "Play (0.01 RITUAL)"}
          </button>

          <div className="info">
            <span>Time: {Math.floor(game.elapsedTime / 60)}:{(game.elapsedTime % 60).toString().padStart(2, '0')}</span>
            <span className="dot">•</span>
            <span>Moves: {game.moves}</span>
            <span className="dot">•</span>
            <span>Pairs: 20</span>
          </div>
        </section>

        <section className="board-wrapper">
          {!canPlay && (
            <div className="board-overlay">
              <p>Press "Play" to start a new game (0.01 RITUAL)</p>
            </div>
          )}
          <GameBoard
            cards={game.cards}
            first={game.first}
            second={game.second}
            onCardClick={canPlay ? game.handleCardClick : () => {}}
          />
          <ResultModal
            open={showResult}
            time={stats.time}
            moves={stats.moves}
            onClose={() => setShowResult(false)}
            onPlayAgain={handlePlayAgain}
          />
        </section>
      </main>
      <Analytics />
    </div>
  );
}

export default App;